import React from 'react';

import Button from '@material-ui/core/Button';

const AppButton = props => {
    return (
        <Button {...props}>{props.children}</Button>
    )
}

export default AppButton;